export const ApplicationName = 'SARP_WWW';

export const QueryParameterNames = {
  ReturnUrl: 'returnUrl',
  Message: 'message'
};

export const LogoutActions = {
  LogoutCallback: 'logout-callback',
    Logout: 'logout',
   LoggedOut: 'logged-out'
};

export const LoginActions = {
  Login: 'login',
  LoginCallback: 'login-callback',
  LoginFailed: 'login-failed',
  Profile: 'profile',
  Register: 'register'
};

const prefix = '/authentication';

export const ApplicationPaths = {
  DefaultLoginRedirectPath: '/',
  ApiAuthorizationClientConfigurationUrl: `_configuration/${ApplicationName}`,
  ApiAuthorizationPrefix: prefix,
  Login: `/${LoginActions.Login}`,
  LoginFailed: `/${LoginActions.LoginFailed}`,
  LoginCallback: `/${LoginActions.LoginCallback}`,
  Register: `/${LoginActions.Register}`,
  Profile: `/${LoginActions.Profile}`,
  LogOut: `/${LogoutActions.Logout}`,
  LoggedOut: `/${LogoutActions.LoggedOut}`,
  LogOutCallback: `/${LogoutActions.LogoutCallback}`,
  IdentityRegisterPath: 'Identity/Account/Register',
  IdentityManagePath: 'Identity/Account/Manage'
};
